export default __webpack_public_path__ + "static/media/phungo.d4dc3ac0.png";